import { BusinessGrowth } from './businessGrowth'
import { LiquiditySolvencyCoverage } from './liquiditySolvencyCoverage'
import { Profitability } from './profitability'

export const Insurance = ({ settingsFS }) => {
  return (
    <>
      <LiquiditySolvencyCoverage settingsFS={settingsFS} />
      <Profitability settingsFS={settingsFS} />
      <BusinessGrowth settingsFS={settingsFS} />
    </>
  )
}
